export default [
  {
    label: 'Automatic',
    value: 'automatic',
    code: 1,
  },
  {
    label: 'Adjusted',
    value: 'adjusted',
    code: 3,
  },
  {
    label: 'Nonrecurring',
    value: 'terminated',
    code: 2,
  },
];
